import { createSvgIcon } from '@mui/material/utils';

const Remove = createSvgIcon(
    <svg viewBox="0 -960 960 960">
        <path d="M200-440v-80h560v80H200Z" />
    </svg>,
    'Remove'
);

export { Remove };
